import { render } from "./throwResult.vue?vue&type=template&id=6bba75db"
import script from "./throwResult.vue?vue&type=script&setup=true&lang=js"
export * from "./throwResult.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/exhibitionManage/components/throwResult.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6bba75db"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6bba75db', __exports__)) {
    console.log('reload')
    api.reload('6bba75db', __exports__)
  }
  
  module.hot.accept("./throwResult.vue?vue&type=template&id=6bba75db", () => {
    console.log('re-render')
    api.rerender('6bba75db', render)
  })

}


export default __exports__